import axios from 'axios';
import { setError, updateMeta } from './globalActions';
import Api from '../Config';

export const getArticle = article => ({
  type: 'GET_ARTICLE',
  article,
});

export const fetchArticle = (lang, options) => (dispatch) => {
  axios.get(`${Api.base + lang}/${Api.article}`, {
    params: { ...options },
    withCredentials: true,
  }).then((response) => {
    const data = response.data;
    dispatch(getArticle(data.content));
    dispatch(updateMeta(data.meta));
  }).catch((error) => {
    if (error.response) {
      dispatch(setError(error.response.status.toString()));
    }
  });
};



// WEBPACK FOOTER //
// ./frontend/js/Base/Actions/articleActions.jsx